import React, { useEffect, useState, useMemo } from "react";
import {Link} from 'react-router-dom'
import userService from "../../../app/services/user.service";
import SecBTN from "../../../UI/SecBTN";
// import { tempdata } from "../tempData";
import TableHeader from "./Header";
import Pagination from "./Pagination";
import Search from "./Search";
import classes from './Table.module.css'
import moment from "moment";

const DataTable = ({profileData,updateList}) => {
  const user_id = JSON.parse(localStorage.getItem("user"))?.data?.user?.user_id;
  const [showEntries, setShowEntries] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = +showEntries;

  const statusChangeHandler = (profile_id,active,profile_name) => {
    const body = {
      profile_id: profile_id,
      active: active===1 ? 0 : 1 ,
      created_by: user_id,
      created_on: moment(new Date()).format("YYYY-MM-DD H:mm:ss"),
    };
    userService.updateProfileStatus(body,profile_id)
    .then((res) => {
      console.log(res);
      updateList(profile_name,active);
      // getProfileData({loader:true});
    })
    .catch(err => {
      console.log(err);
      // toast.error("Something went wrong")
    })
  }
  const headers = [
    { name: "S.No.", field: "index", sortable: false },
    { name: "Profile Name", field: "profile_name", sortable: true },
    { name: "Status", field: "isActive", sortable: false },
    { name: "Created Date", field: "createdDate", sortable: true },
  ];

  const commentsData = useMemo(() => {
    //let computedComments = comments;
    let computedComments = profileData;

    if (search) {
      computedComments = computedComments.filter((comment) =>
        comment.profile_name.toLowerCase().includes(search.toLowerCase())
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [profileData, currentPage, search, sorting, ITEMS_PER_PAGE]);

  return (
    <>
      <div className="d-flex justify-content-between">
        {/* <button onClick={()=>console.log(profileData)}>dsdgv</button> */}
        <div>
          Show{" "}
          <select
            onChange={(e) => {
              setShowEntries(e.target.value);
              console.log(e.target.value);
            }}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            {/* <option value='30'>30</option> */}
            {/* <option value='50'>50</option>
                    <option value='100'>100</option> */}
          </select>{" "}
          enteries
        </div>
        <Search
          onSearch={(value) => {
            setSearch(value);
            setCurrentPage(1);
          }}
        />
      </div>
      <div className="table-responsive">
        <table className="table table-bordered mt-3 mb-0">
          <TableHeader
            className={classes.header}
            headers={headers}
            onSorting={(field, order) => setSorting({ field, order })}
          />
          <tbody>
            {commentsData.map((data, index) => (
              <tr key={data.profile_id}>
                <th scope="row">{index + 1}</th>
                <td className={classes.link}>
                  <Link
                    to={`/profileList/rights/`}
                    state={{"profileId":data.profile_id,"profileName":data.profile_name}}
                  >
                  {/* <Link
                    to={`/profileList/${data.profile_id}/${data.profile_name}/`}
                  > */}
                    {data.profile_name}
                  </Link>
                </td>
                <td><SecBTN onClick={() => statusChangeHandler(data.profile_id,data.active,data.profile_name)} className={data.active === 1 ? classes.active : classes.inactive }>{data.active === 1 ? 'Active' : 'In-active' }</SecBTN></td>
                <td>{moment(data.created_on).format("YYYY-MM-DD H:mm:ss")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="small ">
        Showing{" "}
        <b>
          {+showEntries < profileData.length
            ? +showEntries
            : profileData.length}
        </b>{" "}
        out of {profileData.length} enteries
      </p>
      <div className="mt-4">
        <Pagination
          total={totalItems}
          itemsPerPage={ITEMS_PER_PAGE}
          currentPage={currentPage}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>
    </>
  );
};

export default DataTable;
